<div class="messages-page flex flex-col gap-3">
    <div *ngIf="initialLoading()" class="text-sm text-color-secondary">Loading messages...</div>
    <app-messages-panel *ngIf="!initialLoading()" [messages]="messages()" [count]="0" />
</div>
